import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import type { JobProgress } from "../api/types";
import { formatPercentage } from "../utilities/formatters";

interface Props {
  title: string;
  jobProgress?: JobProgress;
  onCancel?: () => void;
  isCancelling?: boolean;
}

const AsyncJobProgress = ({ title, jobProgress, onCancel, isCancelling }: Props) => {
  const progressPercent = jobProgress?.progressPercent ?? 0;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <Stack spacing={1.5} sx={{ alignItems: "center" }}>
        <Typography noWrap color="textSecondary" sx={{ maxWidth: "40rem" }}>
          {title}
        </Typography>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography variant="caption" noWrap color="textSecondary" sx={{ maxWidth: "40rem" }}>
            {jobProgress?.currentProgressItemName}
          </Typography>
          {jobProgress?.errorMessage && (
            <Typography variant="caption" color="error">
              {jobProgress.errorMessage}
            </Typography>
          )}
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <LinearProgress variant="determinate" value={progressPercent} sx={{ width: "12.5rem" }} />
          <Typography color="textSecondary">{formatPercentage(progressPercent / 100)}</Typography>
        </Stack>
        {onCancel && (
          <Button
            variant="outlined"
            color="secondary"
            loading={isCancelling}
            disabled={!jobProgress || jobProgress.totalProgressItems === 0}
            onClick={onCancel}
          >
            Cancel
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default AsyncJobProgress;
